// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__3SvRi","column":"NotFound_column__YtAB2","columns":"NotFound_columns__1b2tK"};